import React from "react";

const FLEXIBLE_DATE_FIELD_KEYS = new Set([
  "manufacture_year",
  "start_year",
]);

export default function FieldForm({ fields, values, onChange, className = "sm-form" }) {
  const set = (key) => (e) => onChange({ ...values, [key]: e.target.value });

  return (
    <div className={className}>
      {fields.map((f, index) => {
        const showGroup = f.group && fields.findIndex((item) => item.group === f.group) === index;
        const isFlexibleDate = FLEXIBLE_DATE_FIELD_KEYS.has(f.key);
        const inputType = isFlexibleDate ? "text" : (f.type === "date" || f.type === "number" ? f.type : "text");

        return (
          <React.Fragment key={f.key}>
            {showGroup && <div className="sm-form__group-title">{f.group}</div>}
            <div className={`sm-field${f.type === "textarea" ? " sm-form__full sm-field--full" : ""}`}>
              <label className="sm-field__label">{f.label}{f.required ? " *" : ""}</label>
              {f.type === "textarea" ? (
                <textarea
                  className="sm-field__textarea"
                  value={values[f.key] ?? ""}
                  onChange={set(f.key)}
                  placeholder={f.placeholder}
                />
              ) : (
                <input
                  className="sm-field__input"
                  type={inputType}
                  value={values[f.key] ?? ""}
                  onChange={set(f.key)}
                  autoComplete="off"
                  min={f.min}
                  step={f.step}
                  maxLength={isFlexibleDate ? 10 : f.maxLength}
                  inputMode={isFlexibleDate ? "decimal" : f.inputMode}
                  placeholder={isFlexibleDate ? "2025, 06.2025 ёки 15.06.2025" : f.placeholder}
                  title={isFlexibleDate ? "YYYY, MM.YYYY ёки DD.MM.YYYY (ISO форматлари ҳам қабул қилинади)" : f.title}
                />
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
